import React, { useState } from 'react';
import { PencilSquareIcon, TrashIcon } from '@heroicons/react/24/outline';
import TimeSlot from './time_slot';
import { getShiftDuration, formatHoursAndMinutes } from '../utils/workTimeCount';



// ANTEPRIMA CREAZIONE TURNO GIORNALIERO

const DailyShiftPreviewTable = ({ shiftPreviews, onDeleteShift, onShiftPreview, onEditingTimeSlot }) => {
  const [editingIndex, setEditingIndex] = useState(null);

  const handleDeleteShift = (index) => {
    onDeleteShift(index);
  };

  const handleEditShift = (index) => {
    setEditingIndex(index);
    if (onEditingTimeSlot) {
      onEditingTimeSlot(index);
    }
  };

  const close = () => {
    setEditingIndex(null);
    if (onEditingTimeSlot) {
      onEditingTimeSlot(null);
    }
  };

  return (
    <>
      {shiftPreviews.length > 0 && (
        <div className="mt-4 p-5 pb-0 border border-solid-2 border-gray-200 rounded-md shadow-md bg-white w-full mb-4">
          <h2 className="text-sm font-medium text-gray-700 mb-2 text-left">ANTEPRIMA TURNO</h2>
          <table className="min-w-full divide-y divide-gray-200 border border-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th scope="col" className="px-1 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider w-1/4">Inizio Fascia Oraria</th>
                <th scope="col" className="px-1 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider w-1/4">Pausa</th>
                <th scope="col" className="px-1 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider w-1/4">Fine Fascia Oraria</th>
                <th scope="col" className="px-1 py-3 text-center text-xs font-medium text-gray-900 uppercase tracking-wider w-1/4">Azioni</th>
              </tr>
            </thead>
            <tbody className='divide-y divide-gray-200'>
            {shiftPreviews.map((preview, index) => (
              <tr key={index} className="bg-white text-center">
                <td className="px-1 py-2 text-sm whitespace-nowrap text-gray-700">{preview.workStartTime}</td>
                <td className="px-1 py-2 text-sm whitespace-nowrap text-gray-700">
                  {preview.breaks && preview.breaks.length > 0 ? (
                    preview.breaks.map((breakItem, breakIndex) => {
                      return <div key={breakIndex} className="flex flex-col text-gray-700">
                        <span>{breakItem.start_at} - {breakItem.end_at}</span>
                      </div>
                    })
                  ) : (
                    <span>-</span>
                  )}
                </td>
                <td className="px-1 py-2 text-sm whitespace-nowrap text-gray-700">{preview.workEndTime}</td>
                <td className="px-1 py-2 text-sm whitespace-nowrap">
                  <button className="mr-2 text-gray-700 font-bold px-1" title="Modifica" onClick={() => handleEditShift(index)}>
                    <PencilSquareIcon className="h-6 w-6 hover:text-indigo-600" /> 
                  </button>
                  <button className="text-gray-700 font-bold px-1" title="Elimina" onClick={() => handleDeleteShift(index)}>
                    <TrashIcon className="h-6 w-6 hover:text-red-500" /> 
                  </button>
                </td>
              </tr>
            ))}
            </tbody>
          </table>
            {shiftPreviews.length > 0 && (
              <div className='text-gray-700 text-sm font-semibold my-3 text-left'>Totale ore giornaliere:  {' '}
                {formatHoursAndMinutes(
                  shiftPreviews.reduce((acc, preview) => acc + getShiftDuration(preview), 0)
                )}
              </div>
            )}
        </div>
      )}
      {editingIndex !== null && (
        <TimeSlot
          shiftPreview={shiftPreviews[editingIndex]}
          onShiftPreview={(shiftData) => {onShiftPreview(shiftData, editingIndex); close(); } }
          onCancelEdit={close}
        />
      )}
    </>
  );
};

export default DailyShiftPreviewTable;
